/* «Πώς δουλεύει» (design: themes/neropos/design/pages/how.js): pick the load, and the machine shows how many sheets fall
   in, the sheets themselves lie next to it (a half tears along its perforation), and the words say how many washes one
   box gives. Choice cards in a radio group: a click or the arrow keys choose. The machine shown starts its scene again
   (a hidden one waits with its animation reset). The words come from the locale (sections/np-how-dose.liquid). */
(function () {
  var NP = window.NP;
  if (!NP || !NP.$) return;
  var $ = NP.$, $$ = NP.$$;
  var pick = $('[data-dpick]');
  if (!pick) return;
  var box = Number(pick.getAttribute('data-washes')) || 30;
  var one = pick.getAttribute('data-one') || '', other = pick.getAttribute('data-other') || '';
  var DOSE = [{ n: '½', s: 0.5 }, { n: '1', s: 1 }, { n: '2', s: 2 }, { n: '3', s: 3 }];
  var opts = $$('[data-dose]', pick);
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function choose(i, focus) {
    opts.forEach(function (b) {
      var on = Number(b.getAttribute('data-dose')) === i;
      b.setAttribute('aria-checked', String(on)); b.tabIndex = on ? 0 : -1;
      if (on && focus) b.focus();
    });
    $$('[data-m]', pick).forEach(function (m) { m.hidden = Number(m.getAttribute('data-m')) !== i; });
    var d = DOSE[i], washes = Math.floor(box / d.s);
    $('[data-dn]', pick).innerHTML = d.n + ' <span>' + esc(d.s > 1 ? other : one) + '</span>';
    // the sheets themselves: one, two or three; a half tears along its perforation (h)
    $('.dsheets', pick).setAttribute('data-ds', d.s === 0.5 ? 'h' : String(d.s));
    $('[data-dbox]', pick).innerHTML = NP.tx('dose_box_html', { n: washes });
  }
  opts.forEach(function (b) {
    b.addEventListener('click', function () { choose(Number(b.getAttribute('data-dose'))); });
    b.addEventListener('keydown', function (e) {
      var i = Number(b.getAttribute('data-dose')), k = e.key;
      if (k === 'ArrowDown' || k === 'ArrowRight') i = (i + 1) % DOSE.length;
      else if (k === 'ArrowUp' || k === 'ArrowLeft') i = (i + DOSE.length - 1) % DOSE.length;
      else return;
      e.preventDefault(); choose(i, true);
    });
  });
})();
